import React from 'react';
import { Button, ButtonVariants, ButtonColors, Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import styles from './styles/reports-users-notice.module.scss';
import { SYNC_STATE_CATALOG_WARNING } from '../../common/statusClassification/statusClassification';

/**
 * Copy for the `meta.warnings` codes the users endpoint returns when a
 * secondary source failed but the list still rendered. Anything else is
 * shown with its code so it is never silently swallowed.
 */
const WARNING_COPY = Object.freeze({
    [SYNC_STATE_CATALOG_WARNING]:
        'Status colours are unavailable: the sync-state catalog could not be loaded, so status pills show in neutral grey. Retry to fetch it again.',
    journey_stage_unavailable:
        'Journey stages are partly unavailable: the analytics source could not be reached, so users without an advance or a pending direct-deposit switch show as "Unknown".',
    sync_status_unavailable: 'Sync status could not be loaded for this page.',
});

/**
 * Inline notice above the Users table listing which columns are degraded
 * and offering one Retry (a full refresh of the page's data).
 *
 * @param {Object} props
 * @param {string[]} props.warnings
 * @param {() => void} [props.onRetry]
 */
function ReportsUsersNotice({ warnings = [], onRetry }) {
    if (!warnings.length) return null;
    return (
        <div className={styles.notice} role="alert">
            <div className={styles.messages}>
                {warnings.map((code) => (
                    <Text key={code} as={TextAs.P} size={TextSizes.SMALL} className={styles.message}>
                        {WARNING_COPY[code] || `Some data could not be loaded (${code}).`}
                    </Text>
                ))}
            </div>
            {typeof onRetry === 'function' ? (
                <Button
                    variant={ButtonVariants.DEFAULT}
                    color={ButtonColors.SECONDARY}
                    onClick={onRetry}
                    className={styles.retry}
                >
                    Retry
                </Button>
            ) : null}
        </div>
    );
}

export default ReportsUsersNotice;
